import { Button, CircularProgress, Grid, TextField } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';


export default class SignUp extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            numeSocietate: '',
            cui: '',
            numeUser: '',
            email: '',
            parola: '',
            repetaParola: '',
            labRez: '',
            loading:true


        }
    }


    ws = new Ws()
    u = new Utils()
    ls = new LocalStorage()

    componentDidMount() {
    }

    handleChange = (ev) => {
        let val = ev.target.value
        let n = ev.target.name

        console.log('n :>> ', n);
        console.log('val :>> ', val);

        this.setState({ [n]: val })
    }


    checkAndSignUp = async () => {


        if (this.state.parola.length > 5) {
            if (this.state.parola === this.state.repetaParola) {
                let addr = `${this.ws.loginServerAddress}Beneficiari/Create?acceskey=78329hcd9wucnddsu9dk&numeSocietate=${this.state.numeSocietate}&cui=${this.state.cui}&numeUser=${this.state.numeUser}&email=${this.state.email}&parola=${this.state.parola}`


                console.log('addr :>> ', addr);


                addr = encodeURI(addr)

                let r = await fetch(addr)

                let insertSocietate = await r.json()

                console.log('insertSocietate :>> ', insertSocietate);


                if (insertSocietate.Succes) {


                    this.ls.SetUserData(insertSocietate.Content)


                    let objInsertDep = {
                        nume: 'GM',


                    }

                    let objAngajat = {
                        id_categorie: 1,
                        nume: this.state.numeUser || '',
                        email: this.state.email || '',
                        id_user: insertSocietate.Content.InfoUser.IdUser,
                        data_angajarii: this.u.updateSqlNow()
                    }


                    let insertDep = this.ws.insert('departamente', objInsertDep)


                    let insertA = this.ws.insert('angajati', objAngajat)


                    let [iD, iA] = await Promise.all([insertDep, insertA])


                    if (iD.Succes && iA.Succes) {

                        let iUserDrepturi = this.ws.insert('useri_drepturi', {
                            id_utilizator: insertSocietate.Content.InfoUser.IdUser,

                            profil_selectat: 'Manager',

                            acces_rapoarte: 1,
                            acces_setari: 1,
                            acces_utilizatori: 1,

                            acces_extins_proiecte: 1,

                            acces_evaluari: 1,
                            can_edit_evaluari: 1,

                            acces_monitorizare: 1,
                            can_edit_monitorizare: 1,

                            sterge_proiecte: 1

                        })

                        let insertD = this.ws.insert('angajati_departamente', {
                            id_angajat: iA.Content[0].id,
                            id_departament: iD.Content[0].id,
                            sef_departament: 1
                        })


                        let objToInsertDisplay = {
                            margintop: 50,
                            marginleft: 100,
                            id_departament: iD.Content[0].id
                        }

                        let insertDisplay = this.ws.insert('organigrama_display_data', objToInsertDisplay)



                        let [iUD, iDep, iDisp] = await Promise.all([iUserDrepturi, insertD, insertDisplay])

                        if (iUD.Succes && iDep.Succes && iDisp.Succes) {

                            let getUserRights = await this.ws.customSelect('select * from useri where id = @p1', {
                                p1: this.ls.GetUserData().InfoUser.IdUser
                            })


                            if (getUserRights.Succes) {
                                let obj = this.ls.GetUserData();

                                obj.InfoUser.IsAdmin = getUserRights.Content[0].is_admin
                                obj.InfoUser.DrepturiAngajati = getUserRights.Content[0].modifica_angajati
                                obj.InfoUser.AccesProiecte = getUserRights.Content[0].access_proiecte
                                obj.InfoUser.CreazaProiecte = getUserRights.Content[0].creaza_proiecte
                                obj.InfoUser.EsteSef = getUserRights.Content[0].sef_departament
                                obj.InfoUser.AccessFinanciar = getUserRights.Content[0].access_financiar


                                this.ls.SetUserData(obj)

                                let insertDate = await this.ws.insert('companie_date', {
                                    nume:this.state.numeSocietate,
                                    adresa: 'Introdu Adresa',
                                    cui: this.state.cui,
                                    nr_inregistrare: 0,
                                    cota_tva: 0
                                })

                                if(insertDate.Succes){
                                    console.log('insertDate :>> ', insertDate);
                                    // this.props.history.push('/');
                                    // document.location.reload();
                                }

                              

                            } else {
                                this.setState({ labRez: getUserRights.Messsage })
                            }
                        }

                    }

                } else {
                    if (insertSocietate.Content.showMessageToUser) {
                        this.setState({ labRez: insertSocietate.Messsage })
                    } else {
                        this.setState({ labRez: 'Eroare Tehnica, va rugam reveniti !' })
                    }

                }










            } else {
                this.setState({ labRez: 'Parolele nu coincid!' })
            }

        } else {
            this.setState({ labRez: 'Parola trebuie sa fie mai mare de 5 caractere' })
        }

    }


    render() {
        return (
            <div>

                <Grid container className="loginContainer" style={{ borderRadius: 16, marginBottom: 40, marginTop: '35vh' }} >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="with-placeholder"
                            label={this.dictionary.login.societyName}
                            name='numeSocietate'
                            margin="normal"
                            value={this.state.numeSocietate}
                            onChange={this.handleChange}
                        // InputProps={{
                        //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                        // }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="with-placeholder"
                            label={this.dictionary.login.cui}
                            name='cui'
                            margin="normal"
                            value={this.state.cui}
                            onChange={this.handleChange}
                        // InputProps={{
                        //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                        // }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="with-placeholder"
                            label={this.dictionary.login.userName}
                            name='numeUser'
                            margin="normal"
                            value={this.state.numeUser}
                            onChange={this.handleChange}
                        // InputProps={{
                        //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                        // }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="with-placeholder"
                            label={this.dictionary.login.user}
                            name="email"
                            margin="normal"
                            value={this.state.email}
                            onChange={this.handleChange}
                        // InputProps={{
                        //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                        // }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="with-placeholder"
                            label={this.dictionary.login.password}
                            name='parola'
                            margin="normal"
                            value={this.state.parola}
                            onChange={this.handleChange}
                        // InputProps={{
                        //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                        // }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="with-placeholder"
                            label={this.dictionary.login.repeatPassword}
                            name='repetaParola'
                            margin="normal"
                            value={this.state.repetaParola}
                            onChange={this.handleChange}
                        // InputProps={{
                        //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                        // }}
                        />
                    </Grid>


                    <span className='pm-warning-validate'>{this.state.labRez}</span>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                        {this.state.loading &&
                            <CircularProgress
                                style={{
                                    width: 60,
                                    height: 60,
                                    color: '#25e048',
                                    marginTop: '40%'
                                }}
                                value={20}

                            />
                        }

                        {!this.state.loading &&
                            <Button variant="outlined" className='pm-login-button' color="primary" onClick={this.checkAndSignUp}>
                                {this.dictionary.login.signUp}
                            </Button>
                        }

                        {/* <span className='pm-login-signup-text-container'><span className='pm-appbar-list-text'>{this.dictionary.login.or}</span> <span onClick={() => { this.props.history.push('/signup') }} className='pm-appbar-signup-text'>{this.dictionary.login.signUp}</span></span> */}


                    </Grid>

                    <Grid item style={{
                        textAlign: 'right',
                        padding: '10px 40px'
                    }} xs={12} sm={12} md={12} lg={12} xl={12}>
                        <span>{this.dictionary.login.wantToLogIn} <strong onClick={this.props.changeView} style={{ textDecoration: 'underline', cursor: 'pointer' }}>{" " + this.dictionary.login.clickHere}</strong></span>

                    </Grid>

                </Grid>
            </div>
        );
    }
}